import styled from "@emotion/styled";
import React from "react";
import { RadioOptions } from "../survey/questions/radioQuestion";
import { fontP1Regular, fontP2Medium } from "src/design-system/styles/fonts";
import { useRadioSurvey } from "src/hooks/survey/radio-survey";
import { css } from "@emotion/react";
import { compassColors } from "src/utils/styling";
import {
  breakpointDesktopOnly,
  breakpointMobileExtended,
} from "src/design-system/styles/breakpoints";
import i18n from "@i18n";

const Title = styled.div`
  ${fontP1Regular}
`;

const Container = styled.div`
  display: flex;
  padding: 16px 32px;
  flex-direction: column;
  align-items: center;
  @media ${breakpointMobileExtended} {
    width: 100%;
    box-sizing: border-box;
  }
  @media ${breakpointDesktopOnly} {
    border-radius: 16px;
    padding: 48px;
    background-color: ${compassColors.offWhite};
  }
`;

const Body = styled.div`
  width: 100%;
  max-width: 400px;
`;

const options = {
  "1-20 lbs": "t:introClinical:weightLossGoal:options:1to20Lbs",
  "21-50 lbs": "t:introClinical:weightLossGoal:options:21to50Lbs",
  ">50 lbs": "t:introClinical:weightLossGoal:options:greaterThan50Lbs",
  "not decided": "t:introClinical:weightLossGoal:options:notDecided",
};

export function ClinicalWeightLossGoal() {
  const { latestAnswers, setAnswer } = useRadioSurvey("weightLossGoal");

  return (
    <Container>
      <Body>
        <Title>{i18n.t("introClinical:weightLossGoal:title")}</Title>
        <div data-cy-question="weightLossGoal" data-cy="question">
          <RadioOptions
            selected={latestAnswers.weightLossGoal}
            options={options}
            onClick={(option) => {
              setAnswer(option);
            }}
            type="button"
            groupName="weightLossGoal"
            buttonCss={css`
              background-color: ${compassColors.white};
              border-radius: 32px;
              color: ${compassColors.black};
              border: none;
              ${fontP2Medium}
            `}
          />
        </div>
      </Body>
    </Container>
  );
}
